/**
 * 统计 | 地图统计 | 分账账户统计 | 对账单
 */
import Net from '../net';

const NAME = '[StatApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Stat === **/
/** stat-new/home
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statHome(data = {}) {
  Log('statHome data:', data)
  try {
    const res = await Net.http('stat-new/home', { data })
    Log('statHome res:', res)
    return res
  } catch (err) {
    Log('statHome err:', err)
    throw err
  }
}

/** stat-new/income-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statIncome(data = {}) {
  Log('statIncome data:', data)
  try {
    const res = await Net.http('stat-new/income-stat', { data })
    Log('statIncome res:', res)
    return res
  } catch (err) {
    Log('statIncome err:', err)
    throw err
  }
}

/** stat-new/order-count-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statOrderCount(data = {}) {
  Log('statOrderCount data:', data)
  try {
    const res = await Net.http('stat-new/order-count-stat', { data })
    Log('statOrderCount res:', res)
    return res
  } catch (err) {
    Log('statOrderCount err:', err)
    throw err
  }
}

/** stat-new/energy-consumed-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statEnergyConsumed(data = {}) {
  Log('statEnergyConsumed data:', data)
  try {
    const res = await Net.http('stat-new/energy-consumed-stat', { data })
    Log('statEnergyConsumed res:', res)
    return res
  } catch (err) {
    Log('statEnergyConsumed err:', err)
    throw err
  }
}

/** stat-new/pay-method-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statPayMethod(data = {}) {
  Log('statPayMethod data:', data)
  try {
    const res = await Net.http('stat-new/pay-method-stat', { data })
    Log('statPayMethod res:', res)
    return res
  } catch (err) {
    Log('statPayMethod err:', err)
    throw err
  }
}

/** stat-new/user-active-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statUserActive(data = {}) {
  Log('statUserActive data:', data)
  try {
    const res = await Net.http('stat-new/user-active-stat', { data })
    Log('statUserActive res:', res)
    return res
  } catch (err) {
    Log('statUserActive err:', err)
    throw err
  }
}

/** stat-new/order-income-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statMoneyCount(data = {}) {
  Log('statMoneyCount data:', data)
  try {
    const res = await Net.http('stat-new/order-income-stat', { data })
    Log('statMoneyCount res:', res)
    return res
  } catch (err) {
    Log('statMoneyCount err:', err)
    throw err
  }
}

/** stat-new/station-rank
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.page
 * @param {*} data.org_id
*/
export async function statStationIncomeRank(data = {}) {
  Log('statStationIncomeRank data:', data)
  try {
    const res = await Net.http('stat-new/station-rank', { data })
    Log('statStationIncomeRank res:', res)
    return res
  } catch (err) {
    Log('statStationIncomeRank err:', err)
    throw err
  }
}

/** stat-new/get-clearing-trade-item-income-custom
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function getStatClearingTradeItemIncomeCustom(data = {}) {
  Log('getStatClearingTradeItemIncomeCustom data:', data)
  try {
    const res = await Net.http('stat-new/get-clearing-trade-item-income-custom', { data })
    Log('getStatClearingTradeItemIncomeCustom res:', res)
    return res
  } catch (err) {
    Log('getStatClearingTradeItemIncomeCustom err:', err)
    throw err
  }
}

/** stat-new/stat-operator-rank
 * @param {Object} data
 * @param {*} data.stat_order_by
*/
export async function statOperatorRank(data = {}) {
  Log('statOperatorRank data:', data)
  try {
    const res = await Net.http('stat-new/stat-operator-rank', { data })
    Log('statOperatorRank res:', res)
    return res
  } catch (err) {
    Log('statOperatorRank err:', err)
    throw err
  }
}

/** stat-new/stat-org-rank
 * @param {Object} data
 * @param {*} data.stat_order_by
 * @param {*} data.operator_id
*/
export async function statOrgRank(data = {}) {
  Log('statOrgRank data:', data)
  try {
    const res = await Net.http('stat-new/stat-org-rank', { data })
    Log('statOrgRank res:', res)
    return res
  } catch (err) {
    Log('statOrgRank err:', err)
    throw err
  }
}

/** stat-new/stat-station-rank
 * @param {Object} data
 * @param {*} data.stat_order_by
 * @param {*} data.operator_id
 * @param {*} data.org_id
*/
export async function statStationRank(data = {}) {
  Log('statStationRank data:', data)
  try {
    const res = await Net.http('stat-new/stat-station-rank', { data })
    Log('statStationRank res:', res)
    return res
  } catch (err) {
    Log('statStationRank err:', err)
    throw err
  }
}

/** stat-day-data/detail
 * @param {Object} data
 * @param {*} data.time
 * @param {*} data.target_type
 * @param {*} data.target_id
*/
export async function statEfficie(data = {}) {
  Log('statEfficie data:', data)
  try {
    const res = await Net.http('stat-day-data/detail', { data })
    Log('statEfficie res:', res)
    return res
  } catch (err) {
    Log('statEfficie err:', err)
    throw err
  }
}

/** stat-new/get-arpu
 * @param {Object} data
 * @param {*} data.time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statArpu(data = {}) {
  Log('statArpu data:', data)
  try {
    const res = await Net.http('stat-new/get-arpu', { data })
    Log('statArpu res:', res)
    return res
  } catch (err) {
    Log('statArpu err:', err)
    throw err
  }
}

/** stat-new/get-usage
 * @param {Object} data
 * @param {*} data.time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statUsage(data = {}) {
  Log('statUsage data:', data)
  try {
    const res = await Net.http('stat-new/get-usage', { data })
    Log('statUsage res:', res)
    return res
  } catch (err) {
    Log('statUsage err:', err)
    throw err
  }
}

/** stat-new/device-new-stat
 * @param {Object} data
 * @param {*} data.time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function statDeviceIncrease(data = {}) {
  Log('statDeviceIncrease data:', data)
  try {
    const res = await Net.http('stat-new/device-new-stat', { data })
    Log('statDeviceIncrease res:', res)
    return res
  } catch (err) {
    Log('statDeviceIncrease err:', err)
    throw err
  }
}

/** stat-new/device-offline-stat
 * @param {Object} data
*/
export async function statOffLineByType(data = {}) {
  Log('statOffLineByType data:', data)
  try {
    const res = await Net.http('stat-new/device-offline-stat', { data })
    Log('statOffLineByType res:', res)
    return res
  } catch (err) {
    Log('statOffLineByType err:', err)
    throw err
  }
}

/** stat-new/operator-device-offline-stat
 * @param {Object} data
*/
export async function statOffLineByOper(data = {}) {
  Log('statOffLineByOper data:', data)
  try {
    const res = await Net.http('stat-new/operator-device-offline-stat', { data })
    Log('statOffLineByOper res:', res)
    return res
  } catch (err) {
    Log('statOffLineByOper err:', err)
    throw err
  }
}

/** stat-new/history-device-offline-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
*/
export async function statOffLineHistory(data = {}) {
  Log('statOffLineHistory data:', data)
  try {
    const res = await Net.http('stat-new/history-device-offline-stat', { data })
    Log('statOffLineHistory res:', res)
    return res
  } catch (err) {
    Log('statOffLineHistory err:', err)
    throw err
  }
}

/** stat-new/alarm-stat
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function statAlarmCount(data = {}) {
  Log('statAlarmCount data:', data)
  try {
    const res = await Net.http('stat-new/alarm-stat', { data })
    Log('statAlarmCount res:', res)
    return res
  } catch (err) {
    Log('statAlarmCount err:', err)
    throw err
  }
}

/** stat-new/device-count-rank-stat
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function statAmountRank(data = {}) {
  Log('statAmountRank data:', data)
  try {
    const res = await Net.http('stat-new/device-count-rank-stat', { data })
    Log('statAmountRank res:', res)
    return res
  } catch (err) {
    Log('statAmountRank err:', err)
    throw err
  }
}

/** stat-new/test-data
 * @param {Object} data
*/
export async function statTestData(data = {}) {
  Log('statTestData data:', data)
  try {
    const res = await Net.http('stat-new/test-data', { data })
    Log('statTestData res:', res)
    return res
  } catch (err) {
    Log('statTestData err:', err)
    throw err
  }
}

/** stat-new/card-stat-home
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function statCardStatHome(data = {}) {
  Log('statCardStatHome data:', data)
  try {
    const res = await Net.http('stat-new/card-stat-home', { data })
    Log('statCardStatHome res:', res)
    return res
  } catch (err) {
    Log('statCardStatHome err:', err)
    throw err
  }
}

/** stat-new/card-stat-data-board
 * @param {Object} data
 * @param {*} data.org_ids
 * @param {*} data.product_type
 * @param {*} data.card_type
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
*/
export async function statCardStatDataBoard(data = {}) {
  Log('statCardStatDataBoard data:', data)
  try {
    const res = await Net.http('stat-new/card-stat-data-board', { data })
    Log('statCardStatDataBoard res:', res)
    return res
  } catch (err) {
    Log('statCardStatDataBoard err:', err)
    throw err
  }
}

/** stat-new/voice-notice-stat
 * @param {Object} data
*/
export async function statVoiceNoticeStat(data = {}) {
  Log('statVoiceNoticeStat data:', data)
  try {
    const res = await Net.http('stat-new/voice-notice-stat', { data })
    Log('statVoiceNoticeStat res:', res)
    return res
  } catch (err) {
    Log('statVoiceNoticeStat err:', err)
    throw err
  }
}

/** stat-new/voice-notice-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.operator_id
*/
export async function statVoiceNoticeList(data = {}) {
  Log('statVoiceNoticeList data:', data)
  try {
    const res = await Net.http('stat-new/voice-notice-list', { data })
    Log('statVoiceNoticeList res:', res)
    return res
  } catch (err) {
    Log('statVoiceNoticeList err:', err)
    throw err
  }
}

/** stat-new/voice-notice-purchase
 * @param {Object} data
 * @param {*} data.quantity
 * @param {*} data.total_price
*/
export async function statVoiceNoticePurchase(data = {}) {
  Log('statVoiceNoticePurchase data:', data)
  try {
    const res = await Net.http('stat-new/voice-notice-purchase', { data })
    Log('statVoiceNoticePurchase res:', res)
    return res
  } catch (err) {
    Log('statVoiceNoticePurchase err:', err)
    throw err
  }
}

/** stat-new/benefit-package-summary
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function statBenefitPackageSummary(data = {}) {
  Log('statBenefitPackageSummary data:', data)
  try {
    const res = await Net.http('stat-new/benefit-package-summary', { data })
    Log('statBenefitPackageSummary res:', res)
    return res
  } catch (err) {
    Log('statBenefitPackageSummary err:', err)
    throw err
  }
}

/** stat-new/benefit-package-summary-grouped
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
*/
export async function statBenefitPackageSummaryGrouped(data = {}) {
  Log('statBenefitPackageSummaryGrouped data:', data)
  try {
    const res = await Net.http('stat-new/benefit-package-summary-grouped', { data })
    Log('statBenefitPackageSummaryGrouped res:', res)
    return res
  } catch (err) {
    Log('statBenefitPackageSummaryGrouped err:', err)
    throw err
  }
}

/** stat-new/stat-finish-code-order-list-group
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function statStatOrderListGroup(data = {}) {
  Log('statStatOrderListGroup data:', data)
  try {
    const res = await Net.http('stat-new/stat-finish-code-order-list-group', { data })
    Log('statStatOrderListGroup res:', res)
    return res
  } catch (err) {
    Log('statStatOrderListGroup err:', err)
    throw err
  }
}

/** stat-new/list-by-finish-code
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.finish_code
 * @param {*} data.user_id
*/
export async function getStatListByFinishCode(data = {}) {
  Log('getStatListByFinishCode data:', data)
  try {
    const res = await Net.http('stat-new/list-by-finish-code', { data })
    Log('getStatListByFinishCode res:', res)
    return res
  } catch (err) {
    Log('getStatListByFinishCode err:', err)
    throw err
  }
}

/** stat-new/fail-order-stat
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.finish_code
*/
export async function statFailOrderStat(data = {}) {
  Log('statFailOrderStat data:', data)
  try {
    const res = await Net.http('stat-new/fail-order-stat', { data })
    Log('statFailOrderStat res:', res)
    return res
  } catch (err) {
    Log('statFailOrderStat err:', err)
    throw err
  }
}

/** stat-new/fail-order-analysis
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.finish_code
 * @param {*} data.rank_type
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function statFailOrderAnalysis(data = {}) {
  Log('statFailOrderAnalysis data:', data)
  try {
    const res = await Net.http('stat-new/fail-order-analysis', { data })
    Log('statFailOrderAnalysis res:', res)
    return res
  } catch (err) {
    Log('statFailOrderAnalysis err:', err)
    throw err
  }
}


/** === MapStat === **/
/** account-money/account-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.clearing_account_id
*/
export async function mapStatCount(data = {}) {
  Log('mapStatCount data:', data)
  try {
    const res = await Net.http('account-money/account-stat', { data })
    Log('mapStatCount res:', res)
    return res
  } catch (err) {
    Log('mapStatCount err:', err)
    throw err
  }
}

/** stat-new/stat-map-area
 * @param {Object} data
 * @param {*} data.province
 * @param {*} data.city
*/
export async function mapStatStatMapArea(data = {}) {
  Log('mapStatStatMapArea data:', data)
  try {
    const res = await Net.http('stat-new/stat-map-area', { data })
    Log('mapStatStatMapArea res:', res)
    return res
  } catch (err) {
    Log('mapStatStatMapArea err:', err)
    throw err
  }
}

/** stat-new/query-station-list-by-county
 * @param {Object} data
 * @param {*} data.city
 * @param {*} data.county
*/
export async function queryMapStatStation(data = {}) {
  Log('queryMapStatStation data:', data)
  try {
    const res = await Net.http('stat-new/query-station-list-by-county', { data })
    Log('queryMapStatStation res:', res)
    return res
  } catch (err) {
    Log('queryMapStatStation err:', err)
    throw err
  }
}


/** === SettleAccountStat === **/
/** account-money/account-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.clearing_account_id
*/
export async function settleAccountStatCount(data = {}) {
  Log('settleAccountStatCount data:', data)
  try {
    const res = await Net.http('account-money/account-stat', { data })
    Log('settleAccountStatCount res:', res)
    return res
  } catch (err) {
    Log('settleAccountStatCount err:', err)
    throw err
  }
}

/** account-money/account-count-stat
 * @param {Object} data
 * @param {*} data.stat_type
 * @param {*} data.time
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.clearing_account_id
*/
export async function settleAccountStatLineData(data = {}) {
  Log('settleAccountStatLineData data:', data)
  try {
    const res = await Net.http('account-money/account-count-stat', { data })
    Log('settleAccountStatLineData res:', res)
    return res
  } catch (err) {
    Log('settleAccountStatLineData err:', err)
    throw err
  }
}


/** === Statement === **/
/** stat-day-income/get-org-income
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.org_name
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function statementOrgByDay(data = {}) {
  Log('statementOrgByDay data:', data)
  try {
    const res = await Net.http('stat-day-income/get-org-income', { data })
    Log('statementOrgByDay res:', res)
    return res
  } catch (err) {
    Log('statementOrgByDay err:', err)
    throw err
  }
}
